import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=e83311ac&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=ts"
export * from "./Permissions.vue?vue&type=script&lang=ts"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=e83311ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83311ac",
  null
  
)

export default component.exports